import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { AutorizacionImagenes } from '../tiposFormulario/documents/autorizacion-imagenes';
import { RecogidaMenores } from '../tiposFormulario/documents/recogida-menores';
import { Student } from '../tiposFormulario/student';
import { BaseComponent } from '../../shared/base/base.component';



@Component({
  selector: 'app-billing',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent extends BaseComponent implements OnInit {

  @Input()
  public user;
  public userAuth;

  public tempIndex = 0;
  public student = new Student();
  public currentDate = new Date();
  public months = {
    0: 'Enero', 1: 'Febrero', 2: 'Marzo', 3: 'Abril', 4: 'Mayo', 5: 'Junio', 6: 'Julio', 7: 'Agosto',
    8: 'Septiembre', 9: 'Octubre', 10: 'Noviembre', 11: 'Diciembre'
  };
  public monthsToShow = [];
  public arraySend = [];

  public readonly chevronLeft = faChevronLeft;
  public readonly chevronRight = faChevronRight;

  @Input()
  public projects: any[];

  @Output()
  public propagar = new EventEmitter<any>();

  @Output()
  public verPdf = new EventEmitter<any>();

  public recogidaMenores = new RecogidaMenores();
  public authImagenes = new AutorizacionImagenes();

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private router: Router,
              private firestore: AngularFirestore,
              private messageService: MessagesService) {

      super();
  }

  ngOnInit(): void {
    this.courseCurrent = this.students[this.studentCurrent].courseInfoArr[0];
    console.log('el user en documentos es ', this.user);
    // this.getLastFiveMonths();
    this.addReceiptsToStudent();
  }

  addReceiptsToStudent(): Promise<any> {
    this.propagar.emit({ cargando: true, receipts: [] });
    if (this.arraySend.length === 0) {
      const ref = this.firestore.collection('users').doc(this.students[this.studentCurrent].id).ref;
      return this.firestore.collection('receipts-invoices').ref
        .where('student', '==', ref)
        .get()
        .then(receipt => {
          const arrayReceipt = [];
          if (!receipt.empty) {
            receipt.forEach(rec => {
              const receiptData: any = rec.data();
              receiptData.id = rec.id;
              const receiptObject = { month: receiptData.mounth, value: receiptData };
              arrayReceipt.push(receiptObject);
            });
            this.arraySend = arrayReceipt;
            const arraySendNew = arrayReceipt.filter(valueRec => {
              const course: any[] = valueRec.value.idCourse.filter(x => x.id  === this.courseCurrent.id);
              return course.length > 0;
            });
            this.propagar.emit({ cargando: false, receipts: arraySendNew });
            this.getLastFiveMonths();
          } else {
            this.propagar.emit({ cargando: false, receipts: [] });
          }
          return arrayReceipt;
        })
        .catch(error => {
          return error;
        });
    }
    return Promise.resolve();
  }


  getLastFiveMonths(): void {
    this.students[this.studentCurrent].receipts
      .sort((a, b) => {
        const aMonth = a.month;
        const bMonth = b.month;
        const aYear = a.value.year;
        const bYear = b.value.year;
        if (aMonth === bMonth) {
          return (aYear > bYear) ? -1 : (aYear < bYear) ? 1 : 0;
        }
        else {
          return (aMonth > bMonth) ? -1 : 1;
        }
      });
    console.log('los estudiantes en account son ', this.students);
  }
  imprimirPdf(item: any): void {
    // console.log('el item elegido es ', item);
    item.value.courseCurrent = this.courseCurrent;
    this.verPdf.emit(item.value);
  }

  chooseCourseChild($event): void {
    super.chooseCourse($event);
    this.addReceiptsToStudent()
    .then(receipt => {
      const arraySendNew = this.arraySend.filter(valueRec => {
        const course: any[] = valueRec.value.idCourse.filter(x => x.id  === this.courseCurrent.id);
        return course.length > 0;
      });
      if (arraySendNew.length > 0) {
        this.getLastFiveMonths();
      }
      this.propagar.emit({ cargando: false, receipts: arraySendNew });
    })
    .catch(error => {
      this.messageService.openAlertDialog('Hubo un error al consultar los recibos' + error, 'Error');
      this.propagar.emit({ cargando: false, receipts: [] });
    });
  }
}
